import { render, staticRenderFns } from "./luckSquare.vue?vue&type=template&id=094420e7&"
import script from "./luckSquare.vue?vue&type=script&lang=ts&"
export * from "./luckSquare.vue?vue&type=script&lang=ts&"
import style0 from "./luckSquare.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports